import { addMinutes, isBefore, parseISO } from 'date-fns';

interface IDueFields {
  lastSeen: string | null;
  nextScheduledDate: string | null;
}

/**
 * Minutes a learning problem waits after it was last seen (learning_interval1),
 * or null while user_params hasn't loaded yet.
 */
export function learnDelayMinutes(userParams: { learning_interval1: number }[]): number | null {
  const interval = userParams[0]?.learning_interval1;
  return typeof interval === 'number' ? interval : null;
}

/**
 * Learning problems due now: scheduled before the end of today and last seen at least
 * learning_interval1 minutes ago. Nothing is due until user_params has loaded.
 */
export default function dueLearnPs<P extends IDueFields>(
  learnPs: P[],
  userParams: { learning_interval1: number }[],
  now: Date,
  endOfDay: Date,
): P[] {
  const delay = learnDelayMinutes(userParams);
  if (delay === null) return [];
  return learnPs.filter((p) => (
    isBefore(parseISO(p.nextScheduledDate ?? ''), endOfDay)
    && isBefore(addMinutes(parseISO(p.lastSeen ?? ''), delay), now)
  ));
}
